import { APP_COMPANY_CONFIG } from '../../../../../../_CORE/_Config/_Company/AppCompanyConfig';
import { APP_SWITCH_APPEARANCE } from '../../../../../../_CORE/_Config/Plugins/AppSwitchAppearance';
import '../_Styles/Auth.css';

export const AuthShell = ({ children }) => (
    <div className="PBAUTH__shell">
        <main className="PBAUTH__minimal">
            <a className="PBAUTH__brand" href="/" aria-label="Ir al inicio de NOTEBOOK">
                <img
                    className="PBAUTH__brand_logo"
                    src={APP_COMPANY_CONFIG.COMPANY_IMGS.BRAND_DARK}
                    alt="NOTEBOOK"
                    title="NOTEBOOK"
                    style={{
                        width: APP_SWITCH_APPEARANCE.BRAND.HEADER_PUBLIC.width,
                        height: APP_SWITCH_APPEARANCE.BRAND.HEADER_PUBLIC.height,
                    }}
                    draggable="false"
                />
            </a>

            <section className="PBAUTH__form_stage" aria-label="Acceso privado a NOTEBOOK">
                {children}
            </section>
        </main>
    </div>
);

/*
 * Se mantienen estas exportaciones por compatibilidad con posibles imports
 * del proyecto, aunque el Auth minimalista ya no las utiliza visualmente.
 */
export const AuthPanelBadge = ({ id = '', name = '', role = '' }) => (
    <div className="PBAUTH__badge_card">
        <span>{id}</span><strong>{name}</strong><small>{role}</small>
    </div>
);

export const AuthPanelStats = ({ items = [] }) => (
    <div className="PBAUTH__stats">
        {items.map(({ num, label }) => <div key={label}><strong>{num}</strong><span>{label}</span></div>)}
    </div>
);
